import { createAsyncThunk } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { getAxiosByRole } from "../../utils/getAxiosByRole.js";

// Отправка сообщения

export const sendMessage = createAsyncThunk(
  "chat/sendMessage",
  async ({ receiverId, receiverRole, text }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token =
        state.authStudent?.studentToken || state.authTeacher?.teacherToken;
      const decoded = jwtDecode(token);
      const role = decoded?.role;
      const sender_id = decoded?.id;

      if (!token || !role || !sender_id) {
        throw new Error("Invalid or missing token");
      }

      // Защита от отправки самому себе (с учётом роли)
      if (Number(receiverId) === Number(sender_id) && receiverRole === role) {
        throw new Error("You cannot send a message to yourself");
      }
      // console.log(receiverId, receiverRole, text);

      const axios = getAxiosByRole(role);
      await axios.post("/messages", {
        receiver_id: receiverId,
        receiver_role: receiverRole,
        text,
      });

      return {
        sender_id,
        sender_role: role,
        receiver_id: receiverId,
        receiver_role: receiverRole,
        text,
        created_at: new Date().toISOString(),
        is_read: false,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message || "Send failed"
      );
    }
  }
);

export const fetchMessages = createAsyncThunk(
  "chat/fetchMessages",
  async ({ receiverId, receiverRole }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token =
        state.authStudent?.studentToken || state.authTeacher?.teacherToken;
      const decoded = jwtDecode(token);
      const role = decoded?.role;

      if (!token || !role) throw new Error("Invalid token");

      const axios = getAxiosByRole(role);
      const res = await axios.get(
        `/messages/${receiverId}?role=${receiverRole}`
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message || "Fetch failed"
      );
    }
  }
);

export const fetchConversations = createAsyncThunk(
  "chat/fetchConversations",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token =
        state.authStudent?.studentToken || state.authTeacher?.teacherToken;
      const decoded = jwtDecode(token);
      const role = decoded?.role;

      const axios = getAxiosByRole(role);
      const res = await axios.get("/messages/conversations");
      // console.log(res);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to fetch conversations"
      );
    }
  }
);

// Непрочитанные сообщения
export const fetchUnreadCount = createAsyncThunk(
  "chat/fetchUnreadCount",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token =
        state.authStudent?.studentToken || state.authTeacher?.teacherToken;
      const decoded = jwtDecode(token);
      const role = decoded?.role;

      const axios = getAxiosByRole(role);

      const res = await axios.get("/messages/unread-count");

      return res.data.unreadCount;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch unread count"
      );
    }
  }
);

export const markMessagesAsRead = createAsyncThunk(
  "chat/markMessagesAsRead",
  async ({ receiverId, receiverRole }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token =
        state.authStudent?.studentToken || state.authTeacher?.teacherToken;
      const decoded = jwtDecode(token);
      const role = decoded?.role;

      const axios = getAxiosByRole(role);
      await axios.patch(
        `/messages/mark-as-read/${receiverId}?role=${receiverRole}`
      );
      return { receiverId, receiverRole };
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to mark as read"
      );
    }
  }
);

export const fetchUnreadByUser = createAsyncThunk(
  "chat/fetchUnreadByUser",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token =
        state.authStudent?.studentToken || state.authTeacher?.teacherToken;
      const decoded = jwtDecode(token);
      const role = decoded?.role;

      const axios = getAxiosByRole(role);
      const res = await axios.get("/messages/unread-grouped-by-user");
      return res.data; // { userId1: 3, userId2: 1, ... }
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch"
      );
    }
  }
);
export const deleteConversation = createAsyncThunk(
  "chat/deleteConversation",
  async ({ userId, role }, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token =
        state.authStudent?.studentToken || state.authTeacher?.teacherToken;
      const decoded = jwtDecode(token);
      const currentRole = decoded?.role;

      const axios = getAxiosByRole(currentRole);
      await axios.delete("/messages/conversations", {
        data: { userId, role },
      });

      return { userId };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to delete conversation"
      );
    }
  }
);
